function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 17.92C3.058 12.66 6.245 7.84 11.793 7.84c5.549 0 10.047 4.513 10.047 10.08S17.342 28 11.794 28C6.244 28 3.057 23.179 0 17.92z",
  fill: "url(#soltx_inline_svg__paint0_linear_8_4436)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.962 10.36c-1.355 2.35-2.678 4.418-4.183 5.957-1.643 1.68-3.4 2.622-5.573 2.622-4.535 0-8.28-3.802-8.28-8.58 0-4.776 3.745-8.578 8.28-8.578 2.173 0 3.93.942 5.573 2.622 1.505 1.539 2.828 3.607 4.183 5.957zm-9.756 10.36c5.549 0 8.736-4.955 11.794-10.36C24.942 4.955 21.755 0 16.206 0 10.658 0 6.16 4.638 6.16 10.36c0 5.721 4.498 10.36 10.046 10.36z",
  fill: "url(#soltx_inline_svg__paint1_linear_8_4436)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  id: "soltx_inline_svg__paint0_linear_8_4436",
  x1: 10.92,
  y1: 28,
  x2: 10.92,
  y2: 7.84,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#26FFA4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00B2FF"
})), React.createElement("linearGradient", {
  id: "soltx_inline_svg__paint1_linear_8_4436",
  x1: 17.08,
  y1: 0,
  x2: 17.08,
  y2: 20.72,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#90ECFD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#37FCB2"
})));

function SvgSoltxinline(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSoltxinline;